import {
  SAVE_SIGN,
  CLEAR_STORED_SIGNUP_DATA,
  REQUEST_CODE,
  VERIFY_CODE_ERROR,
  HOW_DID_YOU_HEAR,
  SHOW_CHANGE_PASSWORD_ERROR,
  HIDE_CHANGE_PASSWORD_ERROR,
  SAVE_INFO,
  SHOW_REQUEST_CODE_ERROR,
  GET_MEMBERSHIP_AGREEMENT
} from '../config/const';

const initialState = {
  sign: null,
  showResend: false,
  howDid: null,
  errors: {},
  code: null,
  membershipAgreement: null
};
const signupReducer = (state = initialState, action) => {
  switch (action.type) {
  case SAVE_SIGN:
    return {
      ...state,
      sign: action.payload
    };
  case CLEAR_STORED_SIGNUP_DATA:
    return initialState;
  case REQUEST_CODE:
    return {...state, showResend: false};
  case VERIFY_CODE_ERROR:
    return {
      ...state,
      showResend: true
    };
  case HOW_DID_YOU_HEAR:
    return {
      ...state,
      howDid: action.payload
    };
  case SHOW_CHANGE_PASSWORD_ERROR:
    return {
      ...state,
      errors: {
        changePassword: action.payload
      }
    };
  case SHOW_REQUEST_CODE_ERROR:
    return {
      ...state,
      errors: {
        resetPassword: action.payload
      }
    };
  case HIDE_CHANGE_PASSWORD_ERROR:
    return {
      ...state,
      errors: {}
    };
  case SAVE_INFO:
    return {
      ...state,
      info: {...action.payload}
    };

  case GET_MEMBERSHIP_AGREEMENT:
    return {
      ...state,
      membershipAgreement: action.payload.html
    };
  default:
    return state;
  }
};

export default signupReducer;



// WEBPACK FOOTER //
// ./src/reducers/signupReducer.js